export const BRAND = 'On'

export const API_ENDPOINT =
  process.env.TARGET_ENV === 'production'
    ? 'https://www.on.com/?graphql_router=0xdjmg_aa6'
    : 'https://www-staging.on.com/?graphql_router=0xdjmg_aa6'
